"use client";
import { useEffect } from "react";
import type { StatsigUser, StatsigEvent } from "@statsig/js-client";
import { STATSIG_EVENTS } from "../events";

interface LogEventClient {
  logEvent(event: StatsigEvent): void;
}

const logRouteImpression = (client: LogEventClient, location: string) => {
  let entrypoint = location;
  try {
    entrypoint = location.replace(/^\//, "");
  } catch (e) {
    entrypoint = "error parsing route";
  }
  const metadata = {
    route: location,

    // remove leading slash from route
    entrypoint: entrypoint,
  };

  // Standard event naming: Event = "Impression", Value = route path (KIN-175)
  client.logEvent({
    eventName: STATSIG_EVENTS.IMPRESSION,
    value: location,
    metadata,
  });

  console.log("Logging impression event with data: ", metadata);
};

const useImpressionLogger = (
  client: LogEventClient,
  location: string,
  user: StatsigUser
) => {
  useEffect(() => {
    if (user.userID) {
      logRouteImpression(client, location);
    }
  }, [location, user]);
};

export default useImpressionLogger;
